import SelectCompetencia, {
    useCompetencia,
} from '@/global/components/Selects/SelectCompetencia'
import ContentGuide from '@/global/guides/ContentGuide'
import { type CompensacaoManual, compensacaoManual } from '@/service/api'
import { useStore } from '@/store'
import { columns } from '@/templates/ManutencaoDoPonto/CompensacaoManual/columns'
import { Outlet, useOutletContext } from 'react-router-dom'

export default function CompensacaoManualPage() {
    const empresaId = useStore(state => state.companyId)
    const [competencia, setCompetencia] = useCompetencia()

    const { data = [], isLoading } = compensacaoManual.useFetch({
        queryParams: {
            empresaId,
            competencia,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Manutenção do ponto', 'Compensação manual']}
                >
                    <ContentGuide.Filtros SelectEmpresas>
                        <SelectCompetencia
                            value={competencia}
                            onChange={setCompetencia}
                        />
                    </ContentGuide.Filtros>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={columns}
                    rows={data}
                    tableId="compensacao-manual"
                    ToolbarProps={{
                        showQuickFilter: true,
                        showVisibilityButton: true,
                        exportButtonProps: {
                            fileName: 'compensacao-manual',
                        },
                    }}
                    onAdd
                />
            </ContentGuide.Card>
            <Outlet
                context={{
                    data: new Map(data.map(item => [item.id, item])),
                    competencia,
                }}
            />
        </ContentGuide>
    )
}

export function useCompensacaoManualOutletContext() {
    return useOutletContext<{
        data: Map<number, CompensacaoManual>
        competencia: string
    }>()
}
